import type { GtagModel } from '@/common/models/gtag.model';
import { usePaymentConfigs } from '~/stores/paymentConfigs.ts';

export function useCustomGtag() {
  const { gtag } = useGtag();
  const GTAG_ID = 'G-7MV4FLS470';
  const configsStore = usePaymentConfigs();

  function initGtag(): void {
    gtag('js', new Date());
    gtag('config', GTAG_ID);
    gtag('config', 'AW-407765903');
    gtag('config', 'G-DB1L280ZTM');
    gtag('config', 'AW-16691880554');
  }

  async function getGtagParams() {
    const result = {
      ga_user_id: '',
      ga_wbraid: '',
      ga_gbraid: '',
      ga_gclid: '',
    };

    const keys: Array<{
      gtagKey: string
      resultKey: keyof GtagModel
    }> = [
      { gtagKey: 'client_id', resultKey: 'ga_user_id' },
      { gtagKey: 'wbraid', resultKey: 'ga_wbraid' },
      { gtagKey: 'gbraid', resultKey: 'ga_gbraid' },
      { gtagKey: 'gclid', resultKey: 'ga_gclid' },
    ];

    const promises: Array<Promise<void>> = keys.map(({ gtagKey, resultKey }) =>
      new Promise<void>((resolve) => {
        gtag('get', GTAG_ID, gtagKey, (value) => {
          result[resultKey] = value as string;
          resolve();
        });
      }),
    );

    return Promise.all(promises).then(() => result);
  }

  function sendGtmPurchase(amount: number): void {
    gtag('event', 'purchase', {
      currency: configsStore.currentConfig[1].base.currencyCode,
      value: amount,
    });
  }

  return {
    initGtag,
    getGtagParams,
    sendGtmPurchase,
  };
}
